export interface RealityCheckConfigDTO {
  playerRealityCheckPeriod: RealityCheckPeriodDTO;
}

export interface LegacyResponsibleGamingDTO {
  realityCheckPeriod: string;
}

export interface RealityCheckPeriodDTO {
  realityCheckPeriodSeconds?: number;
}

export enum RealityCheckPeriod {
  NONE = 0,
  ONE_MIN = 60,
  FIVE_MINS = 5 * 60,
  TEN_MINS = 10 * 60,
  FIFTEEN_MINS = 15 * 60,
  TWENTY_MINS = 20 * 60,
  THIRTY_MINS = 30 * 60,
  FORTY_MINS = 40 * 60,
  SIXTY_MINS = 60 * 60,
}
